<template>
  <div v-if="hasLoad" class="order-list-page">
    <template v-if="orderList.length > 0">
      <div
        v-for="(item, index) in orderList"
        :key="index"
        class="order-item"
        @click="goDetail(item)"
      >
        <div class="header-wrapper">
          <div>配送时间：{{ item.deliveryDate }}</div>
          <div>{{ item.statusDesc }}</div>
        </div>
        <div class="desc-wrapper">
          <div>{{ item.outboundDesc }}</div>
          <div>出库单号：{{ item.waybillNo }}</div>
        </div>
        <div class="goods-wrapper">
          <div class="image-list">
            <GoodImage
              v-for="good in item.itemList"
              :key="good.item_key"
              class="goog-img"
              :img-url="good.img"
              :width="'64px'"
              :height="'64px'"
              :fit="'cover'"
            ></GoodImage>
          </div>
        </div>
        <div class="tip-wrapper">
          <div class="stage"></div>
          <div class="tip">{{ item.waybillDesc }}</div>
        </div>
        <div class="btn-wrapper">
          <div class="stage"></div>
          <div :class="['btn', borderColorClass, themeColorClass]">
            查看配送单
          </div>
        </div>
      </div>
    </template>
    <empty
      v-if="orderList.length === 0"
      :desc="'暂无配送单'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
    <div v-if="msg" class="msg">{{ msg }}</div>
  </div>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import { API } from '@/api'
import Url from '@mc/mc-utils/js/url/url'
import themeMixin from '@/common/mixins/theme'
import { companyId } from '@/defines/user'
import Empty from '@/common/layout/empty/index'
import { login } from '@/utils/native_interactions/login'
import GoodImage from '@/common/widget/GoodImage/index.vue'
export default {
  components: { Empty, GoodImage },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '我的配送单'
      navBar.setTitle({
        text: '我的配送单'
      })

      vm.getDeliveryOrderList()
    })
  },
  data() {
    return {
      orderList: [],
      msg: '',
      hasLoad: true,
      companyId: '',
      browerInfo: window.matrix,
      selected_company_id: ''
    }
  },
  methods: {
    async getDeliveryOrderList() {
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}

      const orderId = query.order_id || hashQuery.order_id || ''
      this.companyId = query.companyId || hashQuery.companyId || companyId || ''
      this.selected_company_id =
        query.selected_company_id || hashQuery.selected_company_id
      try {
        const parmas = {
          orderId,
          companyId: this.companyId,
          selected_company_id: this.selected_company_id
        }
        if (this.browerInfo.isMallKeyCustomerApp) {
          parmas.channel = 1
          parmas.platform = 1
          parmas.from_mall = 'big_mall'
        }
        const resData = await API.delivery.getWaybillList(parmas)
        this.orderList = resData?.waybliiList || []
        this.msg = resData?.bottom_tip || ''
        this.hasLoad = true
      } catch (e) {
        if (
          e?.res?.error?.code === 1012002 ||
          e?.res?.error?.code === 2003 ||
          e?.res?.error?.code === 1013014
        ) {
          login()
        }
        this.hasLoad = true
      }
    },
    goDetail(item) {
      // 跳转链接
      this.$router.push({
        name: 'deliverOrderDetail',
        query: {
          waybill_no: item.waybillNo,
          companyId: this.companyId,
          useWayBill: 1,
          selected_company_id: this.selected_company_id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.order-list-page {
  height: 100vh;

  padding: 0.24rem 0.24rem 0.2rem 0.24rem;

  background-color: #f5f5f5;
  overflow-y: auto;
  .order-item {
    margin-bottom: 0.2rem;
    padding: 0.2rem;

    background-color: #fff;

    border-radius: 0.12rem;
    .header-wrapper,
    .desc-wrapper {
      @include flex-row-between;
    }
    .header-wrapper {
      @include text(0.28rem, #262626);
    }
    .desc-wrapper {
      margin-top: 0.2rem;
      margin-bottom: 0.24rem;
      @include text(0.24rem, #8c8c8c);
    }
    .goods-wrapper {
      overflow: auto;
      .image-list {
        display: flex;

        width: max-content;

        &::-webkit-scrollbar {
          display: none;
        }
      }
      .goog-img {
        width: 1.28rem;
        height: 1.28rem;
        margin-right: 0.16rem;

        border-radius: 0.16rem;

        border: 1px solid rgba(245, 245, 245, 1);
      }
    }
    .tip-wrapper,
    .btn-wrapper {
      display: flex;

      margin-top: 0.2rem;
      .stage {
        flex: auto;
      }
      .tip,
      .btn {
        flex: none;
      }
      .tip {
        @include text(0.24rem, #333);
      }
      .btn {
        width: 1.68rem;
        height: 0.6rem;

        border-radius: 0.3rem;
        border: 1px solid #0daf52;

        @include flex-row-center;
        @include text(0.24rem, #0daf52);
      }
    }
  }
  .msg {
    margin-top: 0.28rem;
    @include text(0.24rem, #8c8c8c);
    @include flex-row-center;
  }
}
</style>
